import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { cartActions } from "@lemonadetraining/web-shared";
import { Button } from "@lemonadetraining/web-ui";
import { IconShoppingBag } from "@tabler/icons-react";

const CartBadgeButton = () => {
  const dispatch = useDispatch();
  const cartItemCount = useSelector((state) => state.cart.cartItems.length);

  const onCartButtonClick = () => {
    dispatch(cartActions.showCheckout(true));
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={`Shopping cart with ${cartItemCount} item${cartItemCount !== 1 ? "s" : ""}`}
      className="relative w-[50px] h-[50px] p-0 text-white hover:bg-[hsl(var(--primary)/0.15)]"
      onClick={onCartButtonClick}
    >
      <IconShoppingBag className="size-8" />
      {cartItemCount > 0 && (
        <span className="absolute -bottom-1 -right-1 bg-primary text-primary-foreground rounded-full text-xs min-w-5 h-5 flex items-center justify-center">
          {cartItemCount}
        </span>
      )}
    </Button>
  );
};

export default CartBadgeButton;
